import { useParams } from "react-router-dom";

export default function useTab(){
    const {tab} = useParams();

    return ['docs','notes','epp','search'].includes(tab) ? tab: 'course';
}
    